export default "__VITE_ASSET__Bsotxn09__"